import { render, staticRenderFns } from "./Blanklayout.vue?vue&type=template&id=4dab41a3"
import script from "./Blanklayout.vue?vue&type=script&lang=js"
export * from "./Blanklayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports